import { render, staticRenderFns } from "./v-title.vue?vue&type=template&id=e064463c&scoped=true&"
import script from "./v-title.vue?vue&type=script&lang=js&"
export * from "./v-title.vue?vue&type=script&lang=js&"
import style0 from "./v-title.vue?vue&type=style&index=0&id=e064463c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e064463c",
  null
  
)

export default component.exports